<template>
  <div class="counselor-card__review-wrapper">
    <h4
      v-if="counselor.rating > 0"
      class="counselor-card__review-title"
      v-text="counselorGridTexts.customerReviews"
    />
    <rating-stars
      v-if="counselor.rating > 0"
      :rating="parseFloat(counselor.rating)"
      :number-of-reviews="counselor.number_of_reviews"
      class="counselor-card__rating"
      :link="link"
      show-rating-text
    />
    <counselor-archive-card-single-review
      v-for="(review, index) of counselor.top_recent_reviews"
      :key="`${review.id}-${index}`"
      :post="review"
      :link="link"
    />
  </div>
</template>

<script>
import RatingStars from 'Components/RatingStars.vue';
import CounselorArchiveCardSingleReview from './CounselorArchiveCardSingleReview.vue';

export default {
  name: 'CounselorReviews',

  components: {
    CounselorArchiveCardSingleReview,
    RatingStars,
  },

  props: {
    counselor: {
      type: Object,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      counselorGridTexts: theme_vars.counselorGridTexts,
    };
  },
};
</script>
